/**
 * Formats a proposal number based on organization settings
 * @param proposal - Proposal object with proposal_number
 * @param organization - Organization object with settings
 * @returns Formatted proposal number string or null if no number
 */
export function formatProposalNumber(
  proposal: { proposal_number: number | null },
  organization?: { settings?: any }
): string | null {
  if (!proposal.proposal_number) return null;

  const settings = organization?.settings || {};
  const numberingConfig = settings.proposal_numbering || {};

  // Default values
  const prefix = numberingConfig.prefix || '';
  const numberPadding = numberingConfig.number_padding || 4;
  const includeYear = numberingConfig.include_year !== false; // Default true

  // Format the number with padding
  const paddedNumber = proposal.proposal_number.toString().padStart(numberPadding, '0');

  // Handle prefix - if it's {year}, use current year
  let actualPrefix = prefix;
  const isYearPrefix = prefix === '{year}';
  if (isYearPrefix) {
    const year = new Date().getFullYear();
    actualPrefix = year.toString();
  }
  // Build the formatted number
  // If prefix is {year}, it already includes the year, so don't add it again
  if (actualPrefix && includeYear && !isYearPrefix) {
    const year = new Date().getFullYear();
    return `${actualPrefix}-${year}-${paddedNumber}`;
  } else if (actualPrefix) {
    return `${actualPrefix}-${paddedNumber}`;
  } else if (includeYear) {
    const year = new Date().getFullYear();
    return `${year}-${paddedNumber}`;
  } else {
    return paddedNumber;
  }
}
